import clsx from "clsx";
import { RadioButtonGroupOption } from "../RadioButtonGroup";

export interface HorizontalRadioButtonGroupProps {
  name: string;
  value: string | number;
  onChange: (e: { target: { value: string | number } }) => void;
  options: RadioButtonGroupOption[];
  error?: string;
  disabled?: boolean;
}

export const HorizontalRadioButtonGroup: React.FC<HorizontalRadioButtonGroupProps> = ({
  name,
  value,
  onChange,
  options,
  error,
  disabled,
}) => {
  return (
    <div className="flex justify-center gap-4">
      {options.map((option) => (
        <label
          key={option.value}
          className={clsx(
            "group flex cursor-pointer flex-col items-center rounded-lg border-2 p-6 transition-all",
            {
              "border-blue-500 bg-blue-50": String(value) === String(option.value),
              "border-gray-200 hover:border-blue-300": String(value) !== String(option.value),
            },
          )}
        >
          <input
            type="radio"
            name={name}
            value={String(option.value)}
            checked={String(value) === String(option.value)}
            onChange={() => {
              return onChange({ target: { value: option.value } });
            }}
            className="sr-only"
            disabled={disabled}
          />
          <div className="mb-4 flex h-24 w-24 items-center justify-center rounded-full bg-gray-100 fill-gray-600 group-hover:fill-gray-800">
            {option.icon}
          </div>
          <span className="text-lg font-medium text-gray-600 group-hover:text-gray-800">{option.label}</span>
        </label>
      ))}
    </div>
  );
};
